toastr.options = {
    positionClass: 'toast-bottom-right'
};



/*****************
 ** WEBPACK FOOTER
 ** ./js/vendor/toastr.settings.js
 ** module id = 1211
 ** module chunks = 10
 **/